import moment from "moment";

export const parseEventMoments = (event) => {
  const now = moment(new Date());
  const checkInStartAtDate = moment(
    event?.inicio_checkin,
    "YYYY-MM-DD[T]HH:mm:ss"
  );
  const checkInEndsAtDate = moment(event?.fim_checkin, "YYYY-MM-DD[T]HH:mm:ss");

  const checkInHasEnded = now.isAfter(checkInEndsAtDate);
  const checkInWillHappen = now.isBefore(checkInStartAtDate);
  const checkInIsHappening = !checkInWillHappen && !checkInHasEnded;

  const eventStartsAt = moment(
    event?.live_datahora_inicio,
    "YYYY-MM-DD[T]HH:mm:ss"
  );
  const eventEndsAt = moment(
    event?.live_datahora_inicio,
    "YYYY-MM-DD[T]HH:mm:ss"
  );

  eventEndsAt.add(event?.live_duracao_aproximada_minutos, "minutes");

  const eventHasEnded = now.isAfter(eventEndsAt);
  const eventWillHappen = now.isBefore(eventStartsAt);
  const eventIsHappening = !eventWillHappen && !eventHasEnded;

  return {
    checkInStartAtDate,
    checkInEndsAtDate,
    checkInHasEnded,
    checkInWillHappen,
    checkInIsHappening,
    eventStartsAt,
    eventEndsAt,
    eventHasEnded,
    eventWillHappen,
    eventIsHappening,
  };
};
